import React, { useEffect, useState } from "react";

//Import Breadcrumb
import { Divider, FormHelperText, Grid, InputAdornment, Tooltip } from "@mui/material";
import { connect, useDispatch } from 'react-redux';
import { useNavigate, useParams } from "react-router-dom";
import { Card, CardBody, Container } from "reactstrap";
import Breadcrumbs from '../../components/Common/Breadcrumb';
import Label from "../../components/Common/Label";
import LoadingDialog from "../../components/Common/LoadingDialog";
import Notification from "../../components/Common/Notification";
import CheckBox from "../../components/Form/CheckBox";
import CustomButton from "../../components/Form/CustomButton";
import CustomSelect from "../../components/Form/CustomSelect";
import CustomAutocomplete from "../../components/Form/CustomAutocomplete";
import CustomTextField from "../../components/Form/CustomTextField";
import Helpers from "../../helpers/helpers";
import { createOrder, getCustomer, getCustomerDetails, getGeneral, getPointListing, getProductDetails, resetCustomerState, resetOrderState, resetProductState } from "../../store/actions";
import AppDialog from "../../components/Common/AppDialog";
import CustomIconButton from "../../components/Form/CustomIconButton";
import CustomSelectMultiple from "../../components/Form/CustomSelectMultiple";


const AddOrder = ({ title, userPermission, paymentTypeList, shippingMethodList, productList, productDetails, customerSelectListing, customerDetails, countryList, addOrder, pointData }) => {
  const dispatch = useDispatch();
  const { ID } = useParams();

  const navigate = useNavigate();

  const [loading, setIsLoading] = useState(false);
  const [isSameAsShippingAddr, setSameAsShippingAddr] = useState(false);
  const [confirmSubmitModalOpen, setConfirmSubmitModalOpen] = useState(false);
  const [orderItemsArr, setOrderItemsArr] = useState([]);
  const [newItemOrdered, setNewItemOrdered] = useState();
  const [subtotalAmount, setSubtotalAmount] = useState('0.00');
  const [discountAmount, setDiscountAmount] = useState('0.00');
  const [pointEarned, setPointEarned] = useState('0');
  const [totalAmount, setTotalAmount] = useState('0.00');
  const [shippingMethod, setShippingMethod] = useState();
  const [shippingFee, setShippingFee] = useState();
  const [paymentMethod, setPaymentMethod] = useState();
  const [paymentAmount, setPaymentAmount] = useState();
  const [paymentRef, setPaymentRef] = useState();
  const [customerData, setCustomerData] = useState();
  const [shippingData, setShippingData] = useState();
  const [billingData, setBillingData] = useState();
  const [accessoriesSelectList, setAccessoriesSelectList] = useState();
  const [formError, setFormError] = useState();
  const [width, setWidth] = useState(window.innerWidth);
  const [notification, setNotification] = useState({
    open: false,
    msg: "",
    type: "success",
  });


  useEffect(() => {
    dispatch(getGeneral());
    setCustomerData(null);
    dispatch(resetProductState());
    dispatch(resetCustomerState());
    dispatch(resetOrderState());
    dispatch(getPointListing());
    dispatch(getCustomer({
      length: 100,
      page: 0,
      name: '',
      status: 'all',
      sort: 'asc',
      sort_by: 'id'
    }));
    setOrderItemsArr([]);

    const handleResize = () => {
      setWidth(window.innerWidth); // Update state when window resizes
    };
    window.addEventListener("resize", handleResize);

    return (() => {
      dispatch(resetCustomerState());
      setOrderItemsArr([]);
      window.removeEventListener("resize", handleResize); // Cleanup on unmount
    })
  }, []);

  useEffect(() => {
    if (userPermission?.length > 0) {
      !userPermission?.includes("view-order") && navigate('/not-authorized');
    }
  }, [userPermission])

  useEffect(() => {
    if (customerDetails?.name) {
      setCustomerData({
        name: customerDetails?.name,
        phone: customerDetails?.phone,
        email: customerDetails?.email,
        id: customerDetails?.id,
        customer_group_id: customerDetails?.customer_group_id,
      });
    }
    if (customerDetails?.addresses?.length > 0) {
      customerDetails?.addresses?.map((el) => {
        if (el?.default_shipping_address == 1) {
          setShippingData({
            recipient_name: el?.name,
            compnay_name: el?.company,
            email: el?.email,
            phone: el?.phone,
            address_line_1: el?.address_line_1,
            address_line_2: el?.address_line_2,
            city: el?.city,
            region: el?.state,
            postcode: el?.postal_code,
            country_id: parseInt(el?.country_id),
          })
        } else if (el?.default_billing_address == 1) {
          setBillingData({
            recipient_name: el?.name,
            compnay_name: el?.company,
            email: el?.email,
            phone: el?.phone,
            address_line_1: el?.address_line_1,
            address_line_2: el?.address_line_2,
            city: el?.city,
            region: el?.state,
            postcode: el?.postal_code,
            country_id: parseInt(el?.country_id),
          })
        }
      })
    }
    setIsLoading(false);
  }, [customerDetails])

  useEffect(() => {
    if (isSameAsShippingAddr) {
      setBillingData(shippingData);
    }
  }, [isSameAsShippingAddr])

  useEffect(() => {
    if (addOrder?.code === 'success') {
      setIsLoading(false);
      setNotification({ open: true, msg: 'Order created successfully', type: 'success' });
      dispatch(getGeneral());
      setTimeout(() => {
        navigate('/order');
      }, 500);
    } else if (addOrder?.code === 'invalid_field') {
      setIsLoading(false);
      setNotification({
        open: true,
        msg: "Some fields are incomplete or invalid !",
        type: "warning",
      })
      setConfirmSubmitModalOpen(false);
      setFormError(addOrder?.errors);
    }
    setIsLoading(false);
  }, [addOrder])

  useEffect(() => {
    if (productDetails && productDetails?.length !== 0) {
      setNewItemOrdered(null);
      setIsLoading(false);
      let tempArr = orderItemsArr;
      let accessoriesList = [];
      productDetails.discount_type = 'no_discount';
      productDetails.discount_value = '0';
      productDetails.view_specs = false;
      productDetails.quantity = 1;
      productDetails.selected_configuration = [];
      productDetails.configuration_id_list = [];
      productDetails.selected_services = [];
      productDetails.selected_accessories = [{}];
      productDetails.selected_gift = [{}];
      productDetails.configuration_list = [];
      if (productDetails?.service_options_for_order?.length > 0) {
        productDetails.service_options_for_order.forEach((serviceOption) => {
          serviceOption.services?.forEach((service) => {
            if (service?.default_option === 1) {
              // Push the default option inside the options array
              productDetails.selected_services.push({
                service_type_id: service?.main_service_id,
                service_id: serviceOption?.service_id,
                default_option: service?.default_option,
                id: service?.id,
                price: service?.price,
                service_price: service?.price || 0,
                service_type_name: service?.service_type_name,
                years: service?.years,
                options: [service?.options?.filter((el) => el?.is_default === 1)?.length > 0 ? service?.options?.filter((el) => el?.is_default === 1)[0] : service?.options[0]],
              });
            }
          });
        });
      }
      productDetails?.variants?.length > 0 && productDetails.variants?.map((el) => {
        if (!productDetails.configuration_list.some(config => config.configuration_id === el.configuration_id)) {
          productDetails.configuration_list.push({
            configuration_id: el.configuration_id,
            configuration_name: el.configuration_name,
            options: productDetails?.variants?.length > 0 ? productDetails.variants.filter((item) => item.configuration_id === el.configuration_id) : [],
          });
        }
      });
      productDetails.configuration_list?.length > 0 && productDetails.configuration_list?.map((el, index) => {
        el?.options?.length > 0 && el.options?.map((item, idx) => {
          productDetails.configuration_list[index].options[idx].quantity = 1
        })
        if (el?.options?.length > 0 && el?.options[0]?.allow_multiple_select === 1) {
          productDetails.selected_configuration.push([el.options.filter((el) => el.is_default === 1)?.length > 0 ? el.options.filter((el) => el.is_default === 1)[0] : el.options[0]]);
          productDetails.configuration_id_list.push([el.options.filter((el) => el.is_default === 1)?.length > 0 ? el.options.filter((el) => el.is_default === 1)[0]?.id : el.options[0].id]);
        } else {
          productDetails.selected_configuration.push(el.options.filter((el) => el.is_default === 1)?.length > 0 ? el.options.filter((el) => el.is_default === 1)[0] : el.options[0]);
          productDetails.configuration_id_list.push([el.options.filter((el) => el.is_default === 1)?.length > 0 ? el.options.filter((el) => el.is_default === 1)[0]?.id : el.options[0].id]);
        }
      });
      productDetails?.upsells?.length > 0 && productDetails.upsells?.map((el) => {
        el.items?.forEach(item => {
          accessoriesList.push(item);
        });
      })
      productDetails.selected_configuration?.length > 0 && productDetails.selected_configuration?.map((el, index) => {
        if (el?.length > 0) {
          el?.map((x, idx) => {
            productDetails.selected_configuration[index][idx].quantity = 1;
          })
        } else {
          productDetails.selected_configuration[index].quantity = 1;
        }
      })

      productDetails.accessories_list = accessoriesList;
      setAccessoriesSelectList(accessoriesList);
      tempArr.push(productDetails);
      setOrderItemsArr([...tempArr]);
      dispatch(resetProductState());
    }
  }, [productDetails])

  useEffect(() => {
    calculateOrderAmount();
    formError && setFormError(null);
  }, [orderItemsArr, shippingFee, customerData])

  const handleValueChange = (dataObj, field, val, setDataObj) => {
    setDataObj(prevState => ({ ...prevState, [field]: val }));
  }

  const handleOrderItemsChangeAttr = (index, field, val) => {
    let tempArr = orderItemsArr;
    if (field === 'discount_value') {
      if (tempArr[index]["discount_type"] === "percentage" && val > 100) {
        setNotification({ open: true, msg: 'Discount percentage cannot exceed 100%', type: 'warning' });
        return;
      } else {
        let unitPrice = customerData?.customer_group_id ?
          tempArr[index]?.price_groups.filter((el) => el?.customer_group_id === customerData?.customer_group_id)?.length > 0 && tempArr[index]?.price_groups.filter((el) => el?.customer_group_id === customerData?.customer_group_id)[0]?.price :
          tempArr[index]?.aspeed_price;
        if (val > unitPrice) {
          setNotification({ open: true, msg: 'Discount value cannot exceed unit price', type: 'warning' });
          return;
        }
        tempArr[index][field] = val;
      }
    } else {
      tempArr[index][field] = val;
    }
    setOrderItemsArr([...tempArr]);
  }

  const handleOrderItemsChangeConfigurationSub = (indexProduct, el, selectedService, idx) => {
    let tempArr = [...orderItemsArr]; // Clone the orderItemsArr to avoid direct mutation

    let selectedServices = tempArr[indexProduct]?.selected_services;

    if (!selectedServices?.[el]?.options) {
      selectedServices[el] = { options: [] }
    };


    // Ensure selected_services is initialized as an array
    if (!Array.isArray(selectedServices)) {
      selectedServices = tempArr[indexProduct].selected_services = [];
    }

    // Ensure options[idx] exists as an array
    if (!Array.isArray(selectedServices[el].options[idx])) {
      selectedServices[el].options[idx] = [];
    }
    // Check if category_name already exists in the most inner options array
    const categoryExists = selectedServices?.length > 0 && selectedServices?.[el] && selectedServices?.[el]?.options && selectedServices?.[el]?.options.some(
      (option) => (option?.category_name === "" || option?.category_name === null || option?.category_name === undefined) ? false : option?.category_name === selectedService?.category_name
    );
    if (categoryExists) {
      setNotification({
        open: true,
        msg: `Category '${selectedService?.category_name}' already exists in the selected options!`,
        type: 'warning',
      });
      return; // Exit without adding the duplicate
    } else {

      // Push the selectedService into options[idx]
      selectedServices[el].options[idx] = selectedService;

      // Filter out any null or undefined options to keep the structure clean
      selectedServices[el].options = selectedServices[el].options.filter(
        (option) => option !== null && option !== undefined
      );

      setOrderItemsArr(tempArr); // Update the state with the modified array
    }

  };

  const handleOrderItemsChangeConfiguration = (index, field, val, i) => {
    let tempArr = orderItemsArr;
    tempArr[index][field][i] = val;
    console.log("dsadasd", tempArr)
    setOrderItemsArr([...tempArr]);
  }

  const handleOrderItemsAddOptionalItem = (index, field) => {
    let tempArr = orderItemsArr;
    tempArr[index][field].push({});
    setOrderItemsArr([...tempArr]);
  }

  const handleAddOrderProduct = () => {
    if (newItemOrdered) {
      dispatch(getProductDetails({ id: newItemOrdered }));
      setIsLoading(true);
    } else {
      setNotification({ open: true, msg: 'Please select product', type: 'warning' });
    }
  }

  const handleSubmitForm = () => {

    // setIsLoading(true);

    let payload = {
      customer_id: customerData?.id,
      customer_phone: customerData?.phone,
      customer_email: customerData?.email,
      shipping_name: shippingData?.recipient_name,
      shipping_company: shippingData?.compnay_name,
      shipping_email: shippingData?.email,
      shipping_phone: shippingData?.phone,
      shipping_address_line_1: shippingData?.address_line_1,
      shipping_address_line_2: shippingData?.address_line_2,
      shipping_city: shippingData?.city,
      shipping_state: shippingData?.region,
      shipping_postal_code: shippingData?.postcode,
      shipping_country_id: shippingData?.country_id,
      billing_same_as_shipping: isSameAsShippingAddr,
      billing_name: billingData?.recipient_name,
      billing_company: billingData?.compnay_name,
      billing_email: billingData?.email,
      billing_phone: billingData?.phone,
      billing_address_line_1: billingData?.address_line_1,
      billing_address_line_2: billingData?.address_line_2,
      billing_city: billingData?.city,
      billing_state: billingData?.region,
      billing_postal_code: billingData?.postcode,
      billing_country_id: billingData?.country_id,
      shipping_method_id: shippingMethod,
      shipping_fee: shippingFee,
      payment_method_id: paymentMethod,
      order_amount: totalAmount,
      payment_method_ref: paymentRef,
      order_items: []
    }

    if (!customerData) {
      setNotification({ open: true, msg: 'Please select customer', type: 'error' });
      setIsLoading(false);
      return;
    }
    let allFilled = true;
    if (orderItemsArr?.length > 0) {

      orderItemsArr?.map((el, index) => {
        let variantArr = [];
        let serviceArr = [];
        let accessoriesArr = [];
        let giftArr = [];
        let price = el?.price_groups.filter((el) => el?.customer_group_id === customerData?.customer_group_id)?.length > 0 && el?.price_groups.filter((el) => el?.customer_group_id === customerData?.customer_group_id)[0]?.price;
        let discountValue = el?.discount_value;
        el?.selected_configuration?.length > 0 && el?.selected_configuration?.map((item) => {
          if (item?.length > 0) {
            item?.map((configuration) => {
              if (Number(configuration?.quantity) > Number(configuration?.purchase_limit)) {
                setNotification({ open: true, msg: `[${configuration?.configuration_name}] quantity is exceed purchase limit (${configuration?.purchase_limit})`, type: 'error' });
                allFilled = false;
                return;
              }
              variantArr.push({
                configuration_id: configuration?.configuration_id,
                configuration_item_id: configuration?.configuration_item_id,
                product_id: configuration?.product_id,
                quantity: configuration?.quantity,
              })
            })
          } else {
            variantArr.push({
              configuration_id: item?.configuration_id,
              configuration_item_id: item?.configuration_item_id,
              product_id: item?.product_id,
              quantity: item?.quantity,
            })
          }
        })
        el?.selected_services?.length > 0 && el?.selected_services?.map((item, idx) => {
          console.log('item', item)
          if (item?.options?.length > 0) {
            item?.options?.map((serviceOption) => {
              serviceArr.push({
                product_service_option_id: serviceOption?.id || "",
                service_type_id: item?.service_type_id || item?.main_service_id,
                service_id: item?.service_id,
              })
            })
          } else {
            serviceArr.push({
              product_service_option_id: item?.id,
              service_type_id: item?.main_service_id,
              service_id: item?.service_id,
            })
          }
        })
        el?.selected_accessories?.length > 0 && el?.selected_accessories?.map((item, idx) => {
          if (item?.min_purchase_qty && item?.quantity && !((item?.min_purchase_qty <= Number(item?.quantity)) && (Number(item?.quantity) <= item?.max_purchase_qty))) {
            setNotification({ open: true, msg: `Please select quantity between ${item?.min_purchase_qty} and ${item?.max_purchase_qty}`, type: 'error' });
            allFilled = false;
            return;
          } else {
            accessoriesArr.push({
              product_id: item?.upsell_product_id,
              product_upsell_id: item?.product_upsell_id,
              quantity: item?.quantity,
            })
          }
        })
        if (!allFilled) {
          setIsLoading(false);
          return;
        };
        el?.selected_gift?.length > 0 && el?.selected_gift?.map((item) => {
          giftArr.push({ id: item?.gift_id })
        })
        const orderItem = {
          product_id: el?.id,
          price: price,
          quantity: el?.quantity,
          discount_type: el?.discount_type,
          discount_amount: discountValue,
          variants: variantArr.filter(item => Object.keys(item).length > 0 && item.configuration_item_id !== undefined),
          services: serviceArr || [],
          addons: accessoriesArr.filter(item => Object.keys(item).length > 0 && item.product_id !== undefined),
          gifts: giftArr.filter(item => Object.keys(item).length > 0 && item.id !== undefined),
        };
        if (!el?.discount_value) {
          setNotification({ open: true, msg: `Please fill in discount value of product`, type: 'error' });
          setIsLoading(false);
          return;
        }
        // check if product required field is filled
        el?.product_type === "configurable" && variantArr?.length > 0 && variantArr?.map((item) => {
          Object.keys(item).forEach(key => {
            if ((key === 'quantity')) {
              if (!item[key] || item[key] === 0 || item[key] === '0') {
                allFilled = false;
                setConfirmSubmitModalOpen(false);
                setNotification({ open: true, msg: `Please fill in quantity of configuration item`, type: 'error' });
                return;
              }
            }
          });
        })
        accessoriesArr?.length > 0 && accessoriesArr?.map((item) => {
          Object.keys(item).forEach(key => {
            if ((key === 'quantity') && item?.product_id) { //allow submit if no accessories selected
              if (!item[key] || item[key] === 0 || item[key] === '0') {
                allFilled = false;
                setConfirmSubmitModalOpen(false);
                setNotification({ open: true, msg: `Please fill in quantity of accessories`, type: 'error' });
                return;
              }
            }
          });
        })

        Object.keys(orderItem).forEach(key => {
          if ((key === 'quantity' || key === 'discount_type')) {
            if (!orderItem[key] || orderItem[key] === 0 || orderItem[key] === '0') {
              allFilled = false;
              setConfirmSubmitModalOpen(false);
              setNotification({ open: true, msg: `Please fill in ${key === 'discount_type' ? 'discount type' : key} of product`, type: 'error' });
              return;
            }
          }
        });
        if (!allFilled) {
          setIsLoading(false);
          return;
        };

        payload.order_items.push(orderItem);
      })
      if (!allFilled) {
        setIsLoading(false);
        return;
      };
    } else {
      setNotification({ open: true, msg: 'Please add product to order', type: 'error' });
      setIsLoading(false);
      return;
    }

    if (!shippingData || !billingData) {
      setNotification({ open: true, msg: 'Please fill in shipping and billing data', type: 'error' });
      setIsLoading(false);
      return;
    }

    if (!shippingMethod || !shippingFee) {
      setNotification({ open: true, msg: 'Please fill in shipping info', type: 'error' });
      setIsLoading(false);
      return;
    }

    if (!paymentMethod) {
      setNotification({ open: true, msg: 'Please select payment method', type: 'error' });
      setIsLoading(false);
      return;
    }

    if (!paymentAmount) {
      setNotification({ open: true, msg: 'Please fill in payment amount', type: 'error' });
      setIsLoading(false);
      return;
    }
    if (allFilled)
      console.log("dsadasd", payload)

    dispatch(createOrder(payload));
  }

  const handleDeleteSeletedItem = (index) => {
    let tempArr = orderItemsArr;
    tempArr.splice(index, 1);
    setOrderItemsArr([...tempArr]);
  }

  const handleDeleteSeletedServices = (index, idx, sub_idx) => {
    let tempArr = orderItemsArr;
    tempArr[index].selected_services?.[idx]?.options?.splice(sub_idx, 1);
    setOrderItemsArr([...tempArr]);
  }

  const updateSelectedServices = (orderItem, index, newService) => {
    // Ensure selected_services is initialized as an array
    if (!Array.isArray(orderItem.selected_services)) {
      orderItem.selected_services = [];
    }

    // Ensure the specific index exists
    if (!orderItem.selected_services[index]) {
      orderItem.selected_services[index] = { options: [] };
    }

    // Add the new service to the options array
    if (!Array.isArray(orderItem.selected_services[index].options)) {
      orderItem.selected_services[index].options = [];
    }

    orderItem.selected_services[index].options.push(newService);

    return orderItem;
  };

  const handleAddItem = (index, idx) => {
    let tempArr = [...orderItemsArr];
    // Use updateSelectedServices to ensure proper initialization and updates
    tempArr[index] = updateSelectedServices(tempArr[index], idx, {});

    setOrderItemsArr(tempArr);
  };

  const handleSelectCustomer = (customerId) => {
    if (customerId) {
      setIsLoading(true);
      dispatch(getCustomerDetails({ id: customerId }));
    } else {
      setSameAsShippingAddr(false);
      setCustomerData({
        name: "",
        phone: "",
        email: "",
        id: "",
        customer_group_id: ""
      });
      setShippingData({
        recipient_name: "",
        compnay_name: "",
        email: "",
        phone: "",
        address_line_1: "",
        address_line_2: "",
        city: "",
        region: "",
        postcode: "",
        country_id: "",
      })
      setBillingData({
        recipient_name: "",
        compnay_name: "",
        email: "",
        phone: "",
        address_line_1: "",
        address_line_2: "",
        city: "",
        region: "",
        postcode: "",
        country_id: "",
      })
    }

  }
  const calculateOrderAmount = () => {
    let subtotal = 0;
    let totalDiscount = 0;
    const pointsOn = pointData?.length > 0 ? String(pointData[0]?.enabled ?? 1) !== '0' && Number(pointData[0]?.enabled ?? 1) !== 0 : true;
    let pointPerDollar = pointsOn && pointData?.length > 0 && Number(pointData[0]?.dollar) > 0
      ? pointData[0]?.dollar === 1 ? pointData[0]?.point : pointData[0]?.point / pointData[0]?.dollar
      : 0;
    let points = 0;
    let total = 0;
    orderItemsArr?.length > 0 && orderItemsArr?.map(item => {
      let unitPrice = customerData?.customer_group_id ?
        item?.price_groups?.length > 0 ? item?.price_groups?.filter(el => el?.customer_group_id === customerData?.customer_group_id)?.[0]?.price :
          item?.aspeed_price : item?.aspeed_price;

      let finalDiscount = unitPrice * (item?.quantity || 1);

      let finalSubtotal = unitPrice * (item?.quantity || 1);
      subtotal += finalSubtotal;
      if (item?.discount_type && item?.discount_value) {
        if (item?.discount_type === 'fixed_amount') {
          totalDiscount += Number(item?.discount_value);
        } else {
          totalDiscount += (finalDiscount * item?.discount_value / 100);
        }
      }

      if (item.selected_configuration?.length > 0) {
        item.selected_configuration?.map((el) => {
          if (el?.length > 0) {
            el?.map((el) => {
              subtotal += (el?.add_price * (el?.quantity || 1)) || 0
            })
          } else {
            subtotal += (el?.add_price * (el?.quantity || 1)) || 0
          }
        })
      }

      if (item.selected_services?.length > 0) {
        // Flatten the selected_services array including options
        const flattenedServices = item.selected_services.flatMap(service => [
          service,
          ...(service.options?.length > 0 ? service.options : [])
        ]);


        // Sum all prices
        const total = flattenedServices.reduce(
          (acc, el) => acc + Number(el?.price || 0),
          0
        );

        subtotal += total;
      }

      if (item.selected_accessories?.length > 0) {
        item.selected_accessories?.map((el) => {
          subtotal += ((el?.upsell_discounted_aspeed_price || 0) * (el?.quantity || 1))
        })
      }
    });

    points = (subtotal - totalDiscount) * pointPerDollar;
    total = subtotal - totalDiscount;
    if (shippingFee) {
      total = total + Number(shippingFee);
    }
    setDiscountAmount(totalDiscount);
    setSubtotalAmount(subtotal);
    setTotalAmount(total);
    setPaymentAmount(total);
    setPointEarned(points);
  }

  const confirmSubmitModal = () => {
    return (
      <AppDialog
        titleIcon={'add'}
        open={confirmSubmitModalOpen}
        close={() => setConfirmSubmitModalOpen(false)}
        title={'Confirm order creation'}
        negativeTitle={'Cancel'}
        negativePress={() => { setConfirmSubmitModalOpen(false) }}
        positiveTitle={'Confirm order'}
        positivePress={() => handleSubmitForm()}
        width={'40%'}
        negativeButtonStyle={{ border: '0px', color: '#505D69' }}
        actionButtonStyle={'justify-content'}
      >
        Are you sure you want to confirm this order? Once confirmed, the order will proceed to the next step and cannot be reverted.
      </AppDialog>
    )
  }

  const CustomerForm = () => {
    return (
      <Card className="p-2">
        <CardBody>
          <div className="header-2">Customer Information</div>
          <Divider className="my-3" />
          <Grid container spacing={2}>
            <Grid item sm={12} md={12} xs={12}>
              <CustomSelect
                title={'Customer name'}
                values={customerData?.id || '-1'}
                data={customerSelectListing?.data || []}
                valueName={'id'}
                labelName={'name'}
                placeholder={'Please select'}
                onChange={(e) => {
                  handleSelectCustomer(e)
                }}
              />
              {formError && <FormHelperText sx={{ color: "red" }}>{formError.customer_id || ""}</FormHelperText>}
            </Grid>
            <Grid item sm={12} md={6} xs={12}>
              <CustomTextField
                title={'Phone number'}
                values={customerData?.phone}
                type={'number'}
                placeholder={'65123456789'}
                onChange={(e) => {
                  handleValueChange(customerData, 'phone', e, setCustomerData)
                }}
              />
              {formError && <FormHelperText sx={{ color: "red" }}>{formError.customer_phone || ""}</FormHelperText>}
            </Grid>

            <Grid item sm={12} md={6} xs={12}>
              <CustomTextField
                title={'Email address'}
                values={customerData?.email}
                placeholder={'customer.email@example.com'}
                onChange={(e) => {
                  handleValueChange(customerData, 'email', e, setCustomerData)
                }}
              />
              {formError && <FormHelperText sx={{ color: "red" }}>{formError.customer_email || ""}</FormHelperText>}
            </Grid>
          </Grid>
        </CardBody>
      </Card>
    )
  }

  const ShippingAddressForm = () => {
    return (
      <Card className="p-3">
        <CardBody>
          <div className="header-2">Shipping Address</div>
          <Divider className="my-3" />
          <Grid container spacing={2}>
            <Grid item sm={12} md={12} xs={12}>
              <CustomTextField
                title={'Full name'}
                values={shippingData?.recipient_name}
                placeholder={'Recipient name'}
                onChange={(e) => {
                  handleValueChange(shippingData, 'recipient_name', e, setShippingData);
                  if (isSameAsShippingAddr)
                    handleValueChange(billingData, 'recipient_name', e, setBillingData);
                }}
              />
              {formError && <FormHelperText sx={{ color: "red" }}>{formError.shipping_name || ""}</FormHelperText>}
            </Grid>
            <Grid item sm={12} md={12} xs={12}>
              <CustomTextField
                title={'Company name (Optional)'}
                values={shippingData?.compnay_name}
                placeholder={'Company name'}
                onChange={(e) => {
                  handleValueChange(shippingData, 'compnay_name', e, setShippingData);
                  if (isSameAsShippingAddr)
                    handleValueChange(billingData, 'compnay_name', e, setBillingData);
                }}
              />
            </Grid>
            <Grid item sm={12} md={6} xs={12}>
              <CustomTextField
                title={'Email address'}
                values={shippingData?.email}
                placeholder={'customer.email@example.com'}
                onChange={(e) => {
                  handleValueChange(shippingData, 'email', e, setShippingData);
                  if (isSameAsShippingAddr)
                    handleValueChange(billingData, 'email', e, setBillingData);
                }}
              />
              {formError && <FormHelperText sx={{ color: "red" }}>{formError.shipping_email || ""}</FormHelperText>}
            </Grid>
            <Grid item sm={12} md={6} xs={12}>
              <CustomTextField
                title={'Phone number'}
                values={shippingData?.phone}
                type={'phone'}
                placeholder={'65123456789'}
                onChange={(e) => {
                  handleValueChange(shippingData, 'phone', e, setShippingData);
                  if (isSameAsShippingAddr)
                    handleValueChange(billingData, 'phone', e, setBillingData);
                }}
              />
              {formError && <FormHelperText sx={{ color: "red" }}>{formError.shipping_phone || ""}</FormHelperText>}
            </Grid>
            <Grid item sm={12} md={12} xs={12}>
              <CustomTextField
                title={'Address line 1'}
                values={shippingData?.address_line_1}
                placeholder={'Block number, street name'}
                onChange={(e) => {
                  handleValueChange(shippingData, 'address_line_1', e, setShippingData);
                  if (isSameAsShippingAddr)
                    handleValueChange(billingData, 'address_line_1', e, setBillingData);
                }}
              />
              {formError && <FormHelperText sx={{ color: "red" }}>{formError.shipping_address_line_1 || ""}</FormHelperText>}
            </Grid>
            <Grid item sm={12} md={12} xs={12}>
              <CustomTextField
                title={'Address line 2'}
                values={shippingData?.address_line_2}
                placeholder={'Unit number, building name'}
                onChange={(e) => {
                  handleValueChange(shippingData, 'address_line_2', e, setShippingData);
                  if (isSameAsShippingAddr)
                    handleValueChange(billingData, 'address_line_2', e, setBillingData);
                }}
              />
              {formError && <FormHelperText sx={{ color: "red" }}>{formError.shipping_address_line_2 || ""}</FormHelperText>}
            </Grid>
            <Grid item sm={12} md={6} xs={12}>
              <CustomAutocomplete
                title={'Country'}
                valueName={"id"}
                labelName={"name"}
                values={shippingData?.country_id || '-1'}
                placeholder={'Country'}
                onChange={(e, value) => {
                  handleValueChange(shippingData, 'country_id', value?.id || '', setShippingData);
                  if (isSameAsShippingAddr)
                    handleValueChange(billingData, 'country_id', value?.id || '', setBillingData);
                }}
                data={countryList || []}
              />
              {formError && <FormHelperText sx={{ color: "red" }}>{formError.shipping_country_id || ""}</FormHelperText>}
            </Grid>
            <Grid item sm={12} md={6} xs={12}>
              <CustomTextField
                title={'City'}
                values={shippingData?.city}
                placeholder={'City'}
                onChange={(e) => {
                  handleValueChange(shippingData, 'city', e, setShippingData);
                  if (isSameAsShippingAddr)
                    handleValueChange(billingData, 'city', e, setBillingData);
                }}
              />
            </Grid>
            <Grid item sm={12} md={6} xs={12}>
              <CustomTextField
                title={'State / province / region (optional)'}
                values={shippingData?.region}
                placeholder={'State / province / region'}
                onChange={(e) => {
                  handleValueChange(shippingData, 'region', e, setShippingData);
                  if (isSameAsShippingAddr)
                    handleValueChange(billingData, 'region', e, setBillingData);
                }}
              />
              {formError && <FormHelperText sx={{ color: "red" }}>{formError.shipping_state || ""}</FormHelperText>}
            </Grid>
            <Grid item sm={12} md={6} xs={12}>
              <CustomTextField
                title={'Postal code'}
                type={'phone'}
                values={shippingData?.postcode}
                placeholder={'6-digit postal code'}
                onChange={(e) => {
                  handleValueChange(shippingData, 'postcode', e, setShippingData);
                  if (isSameAsShippingAddr)
                    handleValueChange(billingData, 'postcode', e, setBillingData);
                }}
              />
              {formError && <FormHelperText sx={{ color: "red" }}>{formError.shipping_postal_code || ""}</FormHelperText>}
            </Grid>
            <Grid item sm={12} md={12} xs={12} p={6}></Grid>
          </Grid>
        </CardBody>
      </Card>
    )
  }

  const BillingAddressForm = () => {
    return (
      <Card className="p-3">
        <CardBody>
          <div className="header-2">Billing Address</div>
          <Divider className="my-3" />
          <Grid container spacing={2}>
            <Grid item sm={12} md={12} xs={12}>
              <CheckBox
                label={'Same as shipping address'}
                values={isSameAsShippingAddr}
                onChange={(e) => setSameAsShippingAddr(e.target.checked)}
              />
            </Grid>
            <Grid item sm={12} md={12} xs={12}>
              <CustomTextField
                title={'Full name'}
                values={billingData?.recipient_name}
                placeholder={'Recipient name'}
                onChange={(e) => {
                  if (isSameAsShippingAddr) { setSameAsShippingAddr(false) }
                  handleValueChange(billingData, 'recipient_name', e, setBillingData)
                }}
              />
              {formError && <FormHelperText sx={{ color: "red" }}>{formError.billing_name || ""}</FormHelperText>}
            </Grid>
            <Grid item sm={12} md={12} xs={12}>
              <CustomTextField
                title={'Company name (Optional)'}
                values={billingData?.compnay_name}
                placeholder={'Company name'}
                onChange={(e) => {
                  if (isSameAsShippingAddr) { setSameAsShippingAddr(false) }
                  handleValueChange(billingData, 'compnay_name', e, setBillingData)
                }}
              />
            </Grid>
            <Grid item sm={12} md={6} xs={12}>
              <CustomTextField
                title={'Email address'}
                values={billingData?.email}
                placeholder={'customer.email@example.com'}
                onChange={(e) => {
                  if (isSameAsShippingAddr) { setSameAsShippingAddr(false) }
                  handleValueChange(billingData, 'email', e, setBillingData)
                }}
              />
              {formError && <FormHelperText sx={{ color: "red" }}>{formError.billing_email || ""}</FormHelperText>}
            </Grid>
            <Grid item sm={12} md={6} xs={12}>
              <CustomTextField
                title={'Phone number'}
                values={billingData?.phone}
                type={'phone'}
                placeholder={'65123456789'}
                onChange={(e) => {
                  if (isSameAsShippingAddr) { setSameAsShippingAddr(false) }
                  handleValueChange(billingData, 'phone', e, setBillingData)
                }}
              />
              {formError && <FormHelperText sx={{ color: "red" }}>{formError.billing_phone || ""}</FormHelperText>}
            </Grid>
            <Grid item sm={12} md={12} xs={12}>
              <CustomTextField
                title={'Address line 1'}
                values={billingData?.address_line_1}
                placeholder={'Block number, street name'}
                onChange={(e) => {
                  if (isSameAsShippingAddr) { setSameAsShippingAddr(false) }
                  handleValueChange(billingData, 'address_line_1', e, setBillingData)
                }}
              />
              {formError && <FormHelperText sx={{ color: "red" }}>{formError.billing_address_line_1 || ""}</FormHelperText>}
            </Grid>
            <Grid item sm={12} md={12} xs={12}>
              <CustomTextField
                title={'Address line 2'}
                values={billingData?.address_line_2}
                placeholder={'Unit number, building name'}
                onChange={(e) => {
                  if (isSameAsShippingAddr) { setSameAsShippingAddr(false) }
                  handleValueChange(billingData, 'address_line_2', e, setBillingData)
                }}
              />
              {formError && <FormHelperText sx={{ color: "red" }}>{formError.billing_address_line_2 || ""}</FormHelperText>}
            </Grid>
            <Grid item sm={12} md={6} xs={12}>
              <CustomAutocomplete
                title={'Country'}
                valueName={"id"}
                labelName={"name"}
                values={billingData?.country_id || '-1'}
                placeholder={'Country'}
                onChange={(e, value) => {
                  if (isSameAsShippingAddr) { setSameAsShippingAddr(false) }
                  handleValueChange(billingData, 'country_id', value?.id || '', setBillingData)
                }}
                data={countryList || []}
              />
              {formError && <FormHelperText sx={{ color: "red" }}>{formError.billing_country_id || ""}</FormHelperText>}
            </Grid>
            <Grid item sm={12} md={6} xs={12}>
              <CustomTextField
                title={'City'}
                values={billingData?.city}
                placeholder={'City'}
                onChange={(e) => {
                  if (isSameAsShippingAddr) { setSameAsShippingAddr(false) }
                  handleValueChange(billingData, 'city', e, setBillingData)
                }}
              />
              {formError && <FormHelperText sx={{ color: "red" }}>{formError.billing_city || ""}</FormHelperText>}
            </Grid>
            <Grid item sm={12} md={6} xs={12}>
              <CustomTextField
                title={'State / province / region (optional)'}
                values={billingData?.region}
                placeholder={'State / province / region'}
                onChange={(e) => {
                  if (isSameAsShippingAddr) { setSameAsShippingAddr(false) }
                  handleValueChange(billingData, 'region', e, setBillingData)
                }}
              />
              {formError && <FormHelperText sx={{ color: "red" }}>{formError.billing_state || ""}</FormHelperText>}
            </Grid>
            <Grid item sm={12} md={6} xs={12}>
              <CustomTextField
                title={'Postal code'}
                type={'phone'}
                values={billingData?.postcode}
                placeholder={'6-digit postal code'}
                onChange={(e) => {
                  if (isSameAsShippingAddr) { setSameAsShippingAddr(false) }
                  handleValueChange(billingData, 'postcode', e, setBillingData)
                }}
              />
              {formError && <FormHelperText sx={{ color: "red" }}>{formError.billing_postal_code || ""}</FormHelperText>}
            </Grid>
          </Grid>
        </CardBody>
      </Card>
    )
  }

  const renderOrderItem = (itemData, index) => {
    let unitPrice = customerData?.customer_group_id ?
      itemData?.price_groups.filter((el) => el?.customer_group_id === customerData?.customer_group_id)?.length > 0 && itemData?.price_groups.filter((el) => el?.customer_group_id === customerData?.customer_group_id)[0]?.price :
      itemData?.aspeed_price;

    let finalPrice = unitPrice;

    if (itemData?.quantity) {
      finalPrice = unitPrice * itemData?.quantity;
    }

    if (itemData?.discount_type && itemData?.discount_value) {
      if (itemData?.discount_type === 'fixed_amount') {
        finalPrice = finalPrice - itemData?.discount_value;
      } else {
        finalPrice = finalPrice - (finalPrice * itemData?.discount_value / 100);
      }
    }

    // let productImage = itemData?.product_images_details?.length > 0 && itemData?.product_images_details.filter((el) => el.is_thumbnail === 1)[0]?.base64_image;

    return (
      <div style={{ minWidth: 800 }}>
        <Divider className="my-3" />
        <div style={{ flexDirection: 'row', display: 'flex', paddingTop: 10 }}>
          <div className="subheader" style={{ width: '8%', textAlign: 'left' }}>
            <img src={itemData?.thumbnail || Helpers.noImageLink} alt="product-image" style={{ height: 52, maxWidth: '100%', objectFit: 'contain' }} />
          </div>
          <div className="subheader" style={{ width: '40%', }}>
            <div className="subheader d-flex">{itemData?.product_name} <Label.ItemTag label={itemData?.product_type} /></div>
            <div className="subheader-2">SKU: {itemData?.sku}</div>
            {
              itemData?.product_type === 'simple' && itemData?.variants?.length > 0 &&
              <>
                <div className="clickable-text mt-2" onClick={() => handleOrderItemsChangeAttr(index, "view_specs", !itemData?.view_specs)}>
                  {itemData?.view_specs ? 'Hide Specs' : 'View Specs'}
                </div>
                {
                  itemData?.view_specs && itemData?.variants?.length > 0 && itemData?.variants?.map((el) => {
                    return (
                      <div className="mt-1" style={{ color: '#686868', fontSize: 12 }}>
                        <li><span style={{ fontFamily: 'Manrope-Bold' }}>{el?.configuration_name}</span>: {el?.display_name}</li>
                      </div>
                    )
                  })
                }
              </>
            }
          </div>
          <div className="subheader" style={{ width: '10%', textAlign: 'right' }}>S$ {(unitPrice && Number(unitPrice).toFixed(2)) || '0.00'}</div>
          <div className="subheader" style={{ width: '8%', textAlign: 'right', paddingLeft: 10, marginTop: -5 }}>
            <CustomTextField
              values={itemData?.quantity}
              placeholder={'0'}
              type={'number'}
              onChange={(e) => { e === '0' ? handleOrderItemsChangeAttr(index, "quantity", 1) : handleOrderItemsChangeAttr(index, "quantity", e ? parseInt(e) : ''); }}
              error={(itemData?.quantity === 0 || itemData?.quantity === '0' || itemData?.quantity === '') ? '* Invalid quantity' : formError?.[`order_items.${index}.quantity`]?.length > 0 && formError[`order_items.${index}.quantity`]}
            />
          </div>
          <div className="subheader" style={{ width: '16%', textAlign: 'left', paddingLeft: 10 }}>
            <div style={{ textAlign: 'left', marginTop: -5 }}>
              <CustomSelect
                values={itemData?.discount_type || '-1'}
                data={Helpers.discount_type}
                placeholder={'Please select'}
                onChange={(e) => { handleOrderItemsChangeAttr(index, "discount_type", e); handleOrderItemsChangeAttr(index, "discount_value", '0') }}
                error={formError?.order_items?.length > 0 && formError.order_items[index] && !itemData?.discount_type && '* Please select discount type'}
              />
            </div>
            {
              itemData?.discount_type !== 'no_discount' &&
              <CustomTextField
                values={itemData?.discount_value}
                placeholder={'0.00'}
                type={'number'}
                onChange={(e) => handleOrderItemsChangeAttr(index, "discount_value", e)}
                InputProps={{
                  startAdornment: itemData?.discount_type === 2 && <InputAdornment position="start" className='auth-icon'>S$</InputAdornment>,
                  endAdornment: itemData?.discount_type === 1 && <InputAdornment position="end"><span style={{ color: '#999999' }}>%</span></InputAdornment>,
                }}
                width={'100px'}
              />
            }
          </div>
          <div className="subheader" style={{ width: '10%', textAlign: 'right' }}>S$ {(finalPrice && Number(finalPrice).toFixed(2)) || '0.00'}</div>
          <div className="subheader" style={{ width: '8%', textAlign: 'right' }}>
            <CustomIconButton
              iconName={'ri-delete-bin-line'}
              onClick={() => handleDeleteSeletedItem(index)}
              backgroundColor={'#44d62c'}
              color={'white'}
              borderStyle={"1px solid #44d62c"}
            />
          </div>
        </div>
        <div className="mt-3">
          {
            itemData?.product_type === 'configurable' && itemData?.configuration_list?.length > 0 && renderOrderItemConfiguration(itemData, itemData?.configuration_list, index)
          }
          {
            itemData?.product_type === 'configurable' && itemData?.service_options_for_order?.length > 0 && renderOrderItemService(itemData, itemData.service_options_for_order, index)
          }
          {
            itemData?.upsells?.length > 0 && renderOrderItemAccessories(itemData, itemData.upsells, index)
          }
          {
            itemData?.product_gifts?.length > 0 && renderOrderItemFreeGift(itemData, itemData.product_gifts, index)
          }
        </div>

      </div>
    )
  }

  const renderOrderItemConfiguration = (itemData, configurationData, index) => {
    return (
      <div className="my-3" key={`configuration-${itemData?.sku}`}>
        <div className="d-flex mb-3" key={`configuration-${itemData?.sku}`}>
          <div style={{ width: '8%' }}></div>
          <div className="subheader" style={{ width: '92%' }}>{'Configuration'}</div>
        </div>
        {
          configurationData?.length > 0 && configurationData?.map((el, idx) => {
            let totalConfigurationPrice = 0;
            if (itemData?.selected_configuration[idx]?.length > 0) {
              itemData?.selected_configuration[idx]?.map((item) => {
                totalConfigurationPrice += (item?.add_price * (item?.quantity || 1)) || 0
              })
            }
            const configurationList = el?.options || [];
            return (
              <>
                <div className="d-flex my-1" key={`configuration-${itemData?.sku}-${idx}`}>
                  <div style={{ width: '8%' }}></div>
                  <div className="d-flex" style={{ width: '40%' }}>
                    <div className="d-flex align-items-center" style={{ width: '100%' }}>
                      <div className="w-100">
                        {el?.configuration_name}
                        <div className="subheader" style={{ width: '100%', justifyContent: 'right' }}>
                          {
                            itemData?.product_type === 'configurable' && itemData?.selected_configuration?.length > 0 && (itemData?.selected_configuration[idx]?.allow_multiple_select === 1 || itemData?.selected_configuration[idx][0]?.allow_multiple_select === 1) ?
                              <>
                                <CustomSelectMultiple
                                  values={itemData?.configuration_id_list[idx]}
                                  onChange={async (e) => {
                                    let tempArr = orderItemsArr;
                                    let filteredConfiguration = await el?.options.filter((x) => e.includes(x.id));
                                    tempArr[index]["configuration_id_list"][idx] = e;
                                    tempArr[index]["selected_configuration"][idx] = (filteredConfiguration.length > 0) ? filteredConfiguration : [];
                                    // tempArr[index]["selected_configuration"][idx].quantity = 1
                                    setOrderItemsArr([...tempArr]);
                                  }}
                                  placeholder={'Select one or more'}
                                  data={configurationList || []}
                                  labelName={'display_name'}
                                  valueName={'configuration_item_id'}
                                />
                              </>
                              : <CustomSelect
                                values={(itemData?.selected_configuration?.length > 0 && itemData?.selected_configuration?.[idx]?.id) || "-1"}
                                data={el?.options || []}
                                labelName={'display_name'}
                                valueName={'id'}
                                onChange={async (e) => {
                                  let filteredConfiguration = await el?.options.filter((x) => e === (x.id));
                                  if (filteredConfiguration?.length > 0 && filteredConfiguration[0]?.allow_multiple_select === 1) {
                                    let tempArr = orderItemsArr;
                                    tempArr[index]["configuration_id_list"][idx] = [filteredConfiguration[0]?.id];
                                    tempArr[index]["selected_configuration"][idx] = (filteredConfiguration.length > 0) ? filteredConfiguration : [];
                                    setOrderItemsArr([...tempArr]);
                                  } else {
                                    handleOrderItemsChangeConfiguration(index, "selected_configuration", el?.options.filter((x) => x.id === e)?.length > 0 ? el?.options.filter((x) => x.id === e)[0] : {}, idx)
                                  }
                                }}
                                placeholder={'Select'}
                                error={
                                  formError?.[`order_items.${index}.variants.${idx}.quantity`]?.length > 0 && formError[`order_items.${index}.variants.${idx}.quantity`]
                                }
                              />
                          }

                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="d-flex align-items-center justify-content-end pt-4" style={{ width: '10%' }}>
                    {
                      itemData?.selected_configuration[idx]?.length > 0 && itemData?.selected_configuration[idx][0]?.allow_multiple_select === 1 ?
                        (totalConfigurationPrice && Number(totalConfigurationPrice).toFixed(2)) || '0.00'
                        : (itemData?.selected_configuration?.length > 0 && itemData?.selected_configuration[idx]?.add_price && Number(itemData?.selected_configuration[idx]?.add_price).toFixed(2)) || '0.00'
                    }
                  </div>
                  <div style={{ width: '8%', textAlign: 'right', paddingLeft: 10 }}>
                    {/* {
                    itemData?.selected_configuration?.length > 0 && itemData?.selected_configuration[idx]?.purchase_limit === 1 && (itemData?.selected_configuration[idx]?.allow_multiple_select === 1 || itemData?.selected_configuration[idx][0]?.allow_multiple_select === 1)
                    <CustomTextField
                      values={itemData?.selected_configuration[idx]?.quantity}
                      placeholder={'0'}
                      type={'number'}
                      onChange={(e) => {
                        if e && !((Number(e || 0) <= itemData?.selected_configuration[idx]?.purchase_limit))) {
                          setNotification({ open: true, msg: `Please enter quantity between ${'0'} and ${itemData?.selected_configuration[idx]?.purchase_limit + 1}`, type: 'warning' });
                        } else if (!e) {
                          setNotification({ open: true, msg: `Please enter quantity`, type: 'warning' });
                        }
                        let tempArr = orderItemsArr;
                        tempArr[index]["selected_configuration"][idx]['quantity'] = e ? parseInt(e) : e;
                        setOrderItemsArr([...tempArr]);
                      }}
                    />
                  } */}
                  </div>
                  <div style={{ width: '16%' }}></div>
                  <div className="d-flex align-items-center justify-content-end" style={{ width: '10%' }}>
                    {
                      itemData?.selected_configuration[idx]?.length > 0 && itemData?.selected_configuration[idx][0]?.allow_multiple_select === 1 ?
                        (totalConfigurationPrice && Number(totalConfigurationPrice).toFixed(2)) || '0.00'
                        : (itemData?.selected_configuration?.length > 0 && itemData?.selected_configuration[idx]?.add_price && Number(itemData?.selected_configuration[idx]?.add_price).toFixed(2)) || '0.00'
                    }
                    {/* {(itemData?.selected_configuration?.length > 0 && itemData?.selected_configuration[idx]?.add_price && Number(itemData?.selected_configuration[idx]?.add_price).toFixed(2)) || '0.00'} */}
                  </div>
                  <div style={{ width: '8%' }}></div>
                </div>
                <div >
                  {
                    itemData?.selected_configuration[idx]?.length > 0 && itemData?.selected_configuration[idx]?.map((item, num) => {
                      return (
                        <div className="d-flex my-2">
                          <div style={{ width: '8%' }}></div>
                          <div className="d-flex justify-content-between align-items-center" style={{ width: '40%' }}>
                            <div>
                              {item?.display_name}
                              <FormHelperText sx={{ color: "red" }}>
                                {formError?.[`order_items.${index}.variants.${num + (idx)}.quantity`]?.length > 0 && formError[`order_items.${index}.variants.${num + (idx)}.quantity`]}
                              </FormHelperText>
                            </div>
                            <div >
                              <CustomIconButton
                                iconName={'ri-delete-bin-line'}
                                onClick={() => {
                                  let tempArr = orderItemsArr;
                                  tempArr[index]["configuration_id_list"][idx].splice(num, 1);
                                  tempArr[index]["selected_configuration"][idx].splice(num, 1);
                                  setOrderItemsArr([...tempArr]);
                                }}
                                backgroundColor={'#44d62c'}
                                color={'white'}
                                borderStyle={"1px solid #44d62c"}
                              />
                            </div>
                          </div>
                          <div className="d-flex align-items-center justify-content-end" style={{ width: '10%' }}>
                            {Number(item?.add_price).toFixed(2) || '0.00'}
                          </div>
                          <div style={{ width: '8%', textAlign: 'right', paddingLeft: 10 }}>
                            {
                              item?.purchase_limit > 1 && item?.allow_multiple_select === 1 &&
                              <CustomTextField
                                values={item?.quantity}
                                placeholder={'0'}
                                type={'number'}
                                onChange={(e) => {
                                  if (e && !((Number(e || 0) <= item?.purchase_limit))) {
                                    setNotification({ open: true, msg: `Please enter quantity between ${'1'} and ${item?.purchase_limit}`, type: 'warning' });
                                  } else if (!e) {
                                    setNotification({ open: true, msg: `Please enter quantity`, type: 'warning' });
                                  }
                                  let tempArr = orderItemsArr;
                                  tempArr[index]["selected_configuration"][idx][num]['quantity'] = e ? parseInt(e) : e;
                                  setOrderItemsArr([...tempArr]);
                                }}
                              />
                            }

                          </div>
                          <div style={{ width: '16%' }}></div>
                          <div className="d-flex align-items-center justify-content-end" style={{ width: '10%' }}>
                            {
                              Number((item?.add_price || 0) * (item?.quantity || 1)).toFixed(2)
                            }
                          </div>
                          <div style={{ width: '8%' }}></div>
                        </div>
                      )
                    })
                  }
                </div>
              </>

            )
          })
        }

      </div>
    )
  }

  const renderOrderItemService = (itemData, serviceData, index) => {
    return (
      <div className="my-3" key={`service-${itemData?.sku}`}>
        <div className="d-flex mb-3">
          <div style={{ width: '8%' }}></div>
          <div className="subheader" style={{ width: '92%' }}>{'Services (optional)'}</div>
        </div>
        {
          serviceData?.length > 0 && serviceData?.map((el, idx) => {
            let serviceOptions = el?.services?.map(option => ({
              ...option,
              // years: (option?.service_type_name || " ") + "- " + option.years + (option.years > 1 ? ' years' : ' year'),
              years: option.years + (option.years > 1 ? ' years' : ' year'),
              service_id: el?.service_id,
            })) || [];
            const filteredServices = itemData?.selected_services?.filter((service) => el?.services?.some((item) => item.id === service.id));
            const filteredDropdown = serviceOptions?.filter((service) => itemData?.selected_services?.some((item) => item.id === service.id));

            return (
              <>
                <div className="d-flex my-1" key={`service-${itemData?.sku}-${idx}`}>
                  <div style={{ width: '8%' }}></div>
                  <div className="d-flex" style={{ width: '40%' }}>
                    <div className="d-flex align-items-center" style={{ width: '100%' }}>
                      <div className=" w-100">
                        {el?.service_type_name}
                        <div className="d-flex subheader" style={{ width: '100%', justifyContent: 'right' }}>
                          <CustomSelect
                            title={el?.name || "-"}
                            values={(itemData?.selected_services?.length > 0 && itemData?.selected_services[idx]?.id) || "-1"}
                            data={serviceOptions || []}
                            labelName={'years'}
                            valueName={'id'}
                            onChange={(e) => {
                              const data = serviceOptions?.find((x) => x.id === e)
                              const optionData = data?.options?.length > 0 && data?.options?.filter((z, idx) => z?.default_option === 1)
                              let filtered = {
                                ...data,
                                options: optionData?.[0] ? [optionData?.[0]] : [],
                              }

                              handleOrderItemsChangeConfiguration(index, "selected_services", filtered || [], idx);
                            }}
                            placeholder={'Select'}
                          />
                        </div>

                      </div>
                    </div>
                  </div>
                  <div className="d-flex align-items-center justify-content-end pt-4" style={{ width: '10%' }}>{(itemData?.selected_services?.length > 0 && itemData?.selected_services[idx]?.price && Number(itemData?.selected_services[idx]?.price).toFixed(2)) || '0.00'}</div>
                  <div style={{ width: '24%' }}></div>
                  <div className="d-flex align-items-center justify-content-end" style={{ width: '10%' }}>{(itemData?.selected_services?.length > 0 && itemData?.selected_services[idx]?.price && Number(itemData?.selected_services[idx].price).toFixed(2)) || '0.00'}</div>
                  <div style={{ width: '8%' }}></div>
                </div>
                {
                  itemData?.selected_services?.length > 0 && filteredServices[0]?.options?.length > 0 && filteredServices[0]?.options?.map((x, sub_idx) =>
                    <div className="d-flex my-1" key={`service-${itemData?.sku}-${idx}`}>
                      <div style={{ width: '8%' }}></div>
                      <div className="d-flex" style={{ width: '40%' }}>
                        <div className="d-flex align-items-center" style={{ width: '100%' }}>
                          <div className=" w-100">
                            <div style={{ marginLeft: "15px", gap: 0.5 }} className="d-flex align-items-center">
                              <CustomSelect
                                title={"Service Options"}
                                values={x?.id || "-1"}
                                data={filteredDropdown?.[0]?.options?.map(option => ({
                                  ...option,
                                  service_id: filteredDropdown?.[0]?.service_id,
                                  years: ` ${option?.service_type_name} (${option?.years} Years)`
                                })) || []}
                                ableClear={sub_idx !== 0}
                                labelName={'years'}
                                valueName={'id'}
                                onChange={(e) => {
                                  const selectedService = filteredDropdown?.[0]?.options.filter((op) => op?.id == e);
                                  let filtered = {
                                    ...selectedService,
                                    service_id: x?.service_id,
                                  }

                                  if (filtered) {
                                    handleOrderItemsChangeConfigurationSub(index, idx, filtered?.[0], sub_idx);
                                  }
                                }}
                                placeholder={'Select'}
                              />
                              <div className="pt-4">
                                {sub_idx !== 0 &&
                                  <CustomIconButton
                                    iconName={'ri-delete-bin-line'}
                                    onClick={() => handleDeleteSeletedServices(index, idx, sub_idx)}
                                    backgroundColor={'#44d62c'}
                                    color={'white'}
                                    borderStyle={"1px solid #44d62c"}
                                  />
                                }
                                {sub_idx === 0 &&
                                  <CustomIconButton
                                    iconName={'ri-add-line'}
                                    onClick={() => handleAddItem(index, idx)}
                                    backgroundColor={'transparent'}
                                    color={'black'}
                                    borderRadius={"50%"}
                                    borderStyle={"1px solid black"}
                                  />
                                }
                              </div>
                            </div>


                          </div>
                        </div>
                      </div>
                      <div className="d-flex align-items-center justify-content-end pt-4" style={{ width: '10%' }}>{x?.price ? ((x?.price || 0).toFixed(2) || "0.00") : '0.00'}</div>
                      <div style={{ width: '24%' }}></div>
                      <div className="d-flex align-items-center justify-content-end pt-4" style={{ width: '10%' }}>{x?.price ? ((x?.price || 0).toFixed(2) || "0.00") : '0.00'}</div>
                      <div style={{ width: '8%' }}></div>
                    </div>)}
              </>



            )
          })
        }
      </div>
    )
  }

  const renderOrderItemAccessories = (itemData, accessoriesData, index) => {
    return (
      <div className="my-3" key={`accessories-${itemData?.sku}`}>
        <div className="d-flex mb-3">
          <div style={{ width: '8%' }}></div>
          <div className="subheader" style={{ width: '92%' }}>{'Accessories (optional)'}</div>
        </div>

        {
          itemData?.selected_accessories?.length > 0 && itemData.selected_accessories?.map((el, idx) => {
            return (
              <div className="d-flex my-1" key={`accessories-${itemData?.sku}-${idx}`}>
                <div style={{ width: '8%' }}></div>
                <div className="d-flex" style={{ width: '40%' }}>
                  <div className="d-flex align-items-center subheader-2" style={{ width: '100%' }}>
                    <div className="w-100">
                      {`Accessories #${idx + 1}`}
                      <div className="d-flex subheader" style={{ width: '100%', justifyContent: 'right' }}>
                        <CustomSelect
                          values={(el?.id) || "-1"}
                          data={itemData?.accessories_list || []}
                          labelName={'upsell_product_name'}
                          valueName={'id'}
                          onChange={(e) => {
                            if (itemData?.selected_accessories.some(selected => selected?.id === e)) {
                              setNotification({ open: true, msg: 'This accessory has already been selected', type: 'error' });
                              return;
                            }
                            let selectedItem = itemData?.accessories_list.filter((x) => x.id === e)[0];
                            let minQuantity = selectedItem?.min_purchase_qty || 1;
                            handleOrderItemsChangeConfiguration(index, "selected_accessories", { ...selectedItem, quantity: minQuantity }, idx)
                          }}
                          placeholder={'Select'}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="d-flex align-items-center justify-content-end pt-4" style={{ width: '10%' }}>{(el?.upsell_discounted_aspeed_price && Number(el.upsell_discounted_aspeed_price).toFixed(2)) || '0.00'}</div>
                <div style={{ width: '8%', textAlign: 'right', paddingLeft: 10 }} className="d-flex align-items-end">
                  {
                    el?.max_purchase_qty > 1 &&
                    <CustomTextField
                      values={itemData?.selected_accessories[idx]?.quantity}
                      placeholder={'0'}
                      type={'number'}
                      onChange={(e) => {
                        if (e && !((el?.min_purchase_qty <= Number(e || 0)) && (Number(e || 0) <= el?.max_purchase_qty))) {
                          setNotification({ open: true, msg: `Please enter quantity between ${el?.min_purchase_qty} and ${el?.max_purchase_qty}`, type: 'warning' });
                        }
                        let tempArr = orderItemsArr;
                        tempArr[index]["selected_accessories"][idx]['quantity'] = e ? parseInt(e) : e;
                        setOrderItemsArr([...tempArr]);
                      }}
                      error={
                        !((el?.min_purchase_qty <= Number(itemData?.selected_accessories[idx]?.quantity)) && (Number(itemData?.selected_accessories[idx]?.quantity) <= el?.max_purchase_qty)) ? '* Invalid qty' :
                          formError?.[`order_items.${index}.addons.${idx}.quantity`] && '* Exceed available stock'
                      }
                    />
                  }
                </div>
                <div style={{ width: '16%' }}></div>
                <div className="d-flex align-items-center justify-content-end" style={{ width: '10%' }}>{el?.upsell_discounted_aspeed_price ? Number(el.upsell_discounted_aspeed_price * (el?.quantity || 1)).toFixed(2) : '0.00'}</div>
                <div style={{ width: '8%' }}></div>
              </div>
            )
          })
        }
        {
          itemData?.selected_accessories?.length < itemData?.accessories_list?.length &&
          <div className="d-flex mb-4">
            <div style={{ width: '8%' }}></div>
            <div style={{ width: '92%' }} className="clickable-text">
              <div onClick={() => handleOrderItemsAddOptionalItem(index, "selected_accessories")}>+ Add More</div>
            </div>
          </div>
        }
      </div>
    )
  }

  const renderOrderItemFreeGift = (itemData, freeGiftData, index) => {
    return (
      <div className="my-3" key={`free-gift-${itemData?.sku}`}>
        <div className="d-flex mb-3">
          <div style={{ width: '8%' }}></div>
          <div className="subheader" style={{ width: '92%' }}>{'Free Gift (optional)'}</div>
        </div>

        {
          itemData?.selected_gift?.length > 0 && itemData?.selected_gift?.map((el, idx) => {
            let freeGiftList = freeGiftData.filter((gift, num) => !itemData.selected_gift.some(selected => selected?.gift_id === gift?.gift_id) || gift?.gift_id === el?.gift_id);
            return (
              <div className="d-flex my-1" key={`free-gift-${itemData?.sku}-${idx}`}>
                <div style={{ width: '8%' }}></div>
                <div className="d-flex" style={{ width: '40%' }}>
                  <div className="d-flex align-items-center subheader-2" style={{ width: '100%' }}>
                    <div className="w-100">
                      {`Free Gift #${idx + 1}`}
                      <div className="subheader" style={{ width: '100%', justifyContent: 'right' }}>
                        <CustomSelect
                          values={(el?.gift_id) || "-1"}
                          data={freeGiftList || []}
                          labelName={'gift_product_name'}
                          valueName={'gift_id'}
                          onChange={(e) => {
                            if (!e) {
                              handleOrderItemsChangeConfiguration(index, "selected_gift", e, idx)
                              return;
                            } else if (itemData?.selected_gift.some(selected => selected.gift_id === e)) {
                              setNotification({ open: true, msg: 'This gift has already been selected', type: 'error' });
                              return;
                            } else {
                              handleOrderItemsChangeConfiguration(index, "selected_gift", freeGiftData.filter((x) => x?.gift_id === e)[0], idx)
                            }
                          }}
                          placeholder={'Select'}
                          error={formError?.[`order_items.${index}.gifts.${idx}.id`]?.length > 0 && formError[`order_items.${index}.gifts.${idx}.id`]}
                        />
                      </div>
                    </div>

                  </div>

                </div>
                <div className="d-flex align-items-center justify-content-end pt-4" style={{ width: '10%' }}>0.00</div>
                <div style={{ width: '24%' }}></div>
                <div className="d-flex align-items-center justify-content-end" style={{ width: '10%' }}>0.00</div>
                <div style={{ width: '8%' }}></div>
              </div>
            )
          })
        }
        {
          itemData?.selected_gift?.length < freeGiftData?.length &&
          <>
            <div className="d-flex mb-4">
              <div style={{ width: '8%' }}></div>
              <div style={{ width: '92%' }} className="clickable-text">
                <div onClick={() => handleOrderItemsAddOptionalItem(index, "selected_gift")}>+ Add More</div>
              </div>
            </div>
          </>
        }
      </div>
    )
  }

  const ItemOrderForm = () => {

    return (
      <Card className="p-3">
        <CardBody>
          <div className="header-2">Item Ordered</div>
          <Divider className="my-3" />
          <Grid container textAlign={'right'} spacing={2}>
            <Grid item md={11} sm={10.5} xs={9} mb={1} textAlign={'left'}>
              <CustomAutocomplete
                title={'Item ordered'}
                valueName={"value"}
                labelName={"label"}
                values={parseInt(newItemOrdered)}
                // placeholder={'Select product'}
                onChange={(e, value) => { setNewItemOrdered(value?.value) }}
                data={productList || []}
              />
            </Grid>
            <Grid item md={1} sm={1.5} xs={3} display={'flex'} alignItems={'end'} justifyContent={'end'} pb={1}>
              <CustomButton title={'Add'} press={() => handleAddOrderProduct()} backgroundColor={'#101010'} textColor={'white'} />
            </Grid>
          </Grid>
          <div style={{ width: '100%', overflowX: 'auto' }}>
            <div style={{ flexDirection: 'row', display: 'flex', paddingTop: 10, minWidth: 800 }}>
              <div className="subheader" style={{ width: '48%' }}>Item Name</div>
              <div className="subheader" style={{ width: '10%', textAlign: 'right' }}>Unit Price</div>
              <div className="subheader" style={{ width: '8%', textAlign: 'center' }}>Quantity</div>
              <div className="subheader" style={{ width: '16%', textAlign: 'right' }}>Discount (Optional)</div>
              <div className="subheader" style={{ width: '10%', textAlign: 'right' }}>Total</div>
              <div className="subheader" style={{ width: '8%', textAlign: 'right' }}>Action</div>
            </div>
            {
              orderItemsArr?.length > 0 && orderItemsArr?.map((el, idx) => {
                return (
                  renderOrderItem(el, idx)
                )
              })
            }
            {
              orderItemsArr?.length === 0 &&
              <div className="d-flex justify-content-center align-items-center mt-3 subheader-2" style={{ height: 100, borderTop: '1px solid #e0e0e0' }}>
                <div>No item ordered</div>
              </div>
            }
          </div>

          <Divider className="my-3" />
          <Grid container spacing={2}>
            <Grid item md={6} sm xs={12}>
              <CustomSelect
                title={'Shipping Method'}
                values={shippingMethod || '-1'}
                labelName={'title'}
                valueName={'id'}
                data={shippingMethodList || []}
                placeholder={'Please select'}
                onChange={setShippingMethod}
              />
              {formError && <FormHelperText sx={{ color: "red" }}>{formError.shipping_method_id || ""}</FormHelperText>}
            </Grid>
            <Grid item md={6} sm xs={12}>
              <CustomTextField
                title={'Shipping Fee'}
                values={shippingFee}
                placeholder={'0.00'}
                type={'number'}
                onChange={setShippingFee}
                InputProps={{
                  startAdornment: <InputAdornment position="start"><span style={{ color: '#999999' }}>S$</span></InputAdornment>,
                }}
              />
            </Grid>
          </Grid>
          <Divider className="my-3" />
          <Grid container>
            <Grid item md={8} sm={0} xs={0}></Grid>
            <Grid item md={4} sm={12} xs={12}>
              <div className="d-flex justify-content-between">
                <div>Subtotal</div>
                <div>S$ {(subtotalAmount && Number(subtotalAmount).toFixed(2)) || '0.00'}</div>
              </div>
              <div className="d-flex justify-content-between mt-1">
                <div>Total discount</div>
                <div>-S$ {(discountAmount && Number(discountAmount).toFixed(2)) || '0.00'}</div>
              </div>
              <div className="d-flex justify-content-between mt-1">
                <div>Shipping</div>
                <div>S$ {(shippingFee && Number(shippingFee).toFixed(2)) || '0.00'}</div>
              </div>
              {(pointData?.[0] == null || String(pointData[0]?.enabled ?? 1) !== '0') && (
                <div className="d-flex justify-content-between mt-1">
                  <div>
                    Points Earned
                    <Tooltip title={'Points are awarded after order completion.'} className="mx-1" placement="top"><i className="ri-information-line" /></Tooltip>
                  </div>
                  <div>{pointEarned || '0'}</div>
                </div>
              )}
              <div className="d-flex justify-content-between subheader mt-1">
                <div>Total</div>
                <div>S$ {(totalAmount && Number(totalAmount).toFixed(2)) || '0.00'}</div>
              </div>
            </Grid>
          </Grid>

        </CardBody>
      </Card>
    )
  }

  const PaymentForm = () => {
    return (
      <Card className="p-3">
        <CardBody>
          <div className="header-2">Payment</div>
          <Divider className="my-3" />
          <Grid container spacing={2}>
            <Grid item md={6} sm={6} xs={12}>
              <CustomSelect
                title={'Payment method'}
                values={paymentMethod || '-1'}
                placeholder={'Please select'}
                labelName={'type'}
                data={paymentTypeList || []}
                onChange={setPaymentMethod}
              />
              {formError && <FormHelperText sx={{ color: "red" }}>{formError.payment_method_id || ""}</FormHelperText>}
            </Grid>
            <Grid item md={6} sm={6} xs={12}>
              <CustomTextField
                title={'Amount'}
                values={paymentAmount}
                type={'number'}
                placeholder={'0.00'}
                onChange={setPaymentAmount}
                disabled={true}
                InputProps={{
                  startAdornment: <InputAdornment position="start"><span style={{ color: '#999999' }}>S$</span></InputAdornment>,
                }}
              />
            </Grid>
            <Grid item md={6} sm={6} xs={12}>
              <CustomTextField
                title={'Payment reference (Optional)'}
                values={paymentRef}
                placeholder={'Reference'}
                onChange={setPaymentRef}
              />
            </Grid>
          </Grid>
        </CardBody>
      </Card>
    )
  }

  return (
    <React.Fragment>
      {
        width <= 425 &&
        <div className="mobile-button-container">
          <CustomButton
            title={'Save'}
            press={() => setConfirmSubmitModalOpen(true)}
            backgroundColor={'#101010'}
            textColor={'white'}
            width={'100%'}
          />
        </div>
      }
      <div style={{ width: '-webkit-fill-available', position: 'fixed', zIndex: 1, backgroundColor: 'white', height: 150, borderBottom: '1px solid #e0e0e0' }}>
        <div className="page-content">
          <Breadcrumbs
            backRoute={"/order"}
            breadcrumbItems={[{ title: "Orders", link: "/order" },
            { title: title, link: "#" },
            ]}
          >
            {
              width > 425 &&
              <CustomButton
                title={'Save'}
                press={() => setConfirmSubmitModalOpen(true)}
                backgroundColor={'#101010'}
                textColor={'white'}
              />
            }
          </Breadcrumbs>
        </div>
      </div>
      <div className="page-content" style={{ marginTop: 80 }}>
        <LoadingDialog open={loading} />
        <Container fluid>
          <Notification notification={notification} setNotification={setNotification} />
          <div style={{}}>

          </div>
          <Grid container spacing={2}>
            <Grid item sm={12} lg={12}>
              {CustomerForm()}
            </Grid>
            <Grid item sm={12} md={6} lg={6}>
              {ShippingAddressForm()}
            </Grid>
            <Grid item sm={12} md={6} lg={6}>
              {BillingAddressForm()}
            </Grid>
            <Grid item sm={12} md={12} lg={12} xs={12}>
              {ItemOrderForm()}
            </Grid>
            <Grid item sm={12} md={12} lg={12}>
              {PaymentForm()}
            </Grid>
          </Grid>
        </Container>
        {confirmSubmitModal()}
      </div>
    </React.Fragment >
  );
};

function mapStateToProps({ Login, General, Order, Product, Customer, Setting }) {
  let listing = General.products?.length > 0 ? General.products?.filter((el) => el?.product_type !== 'variant') : [];
  const productList = Object.entries(listing)?.map(([key, value]) => ({
    label: value.name,
    value: value.id
  }));
  const shippingMethodList = General.shipping_methods?.length > 0 ? General.shipping_methods?.filter((item) => item?.status === 1) : [];
  return {
    userPermission: Login.permissionArry,
    paymentTypeList: General.payment_type,
    shippingMethodList: shippingMethodList,
    productList: productList,
    productDetails: Product.productDetails?.data,
    customerSelectListing: Customer.customer.data,
    customerDetails: Customer.customerDetails,
    countryList: General.countries,
    addOrder: Order.addOrder,
    pointData: Setting.pointListing.data?.data,
  };
}

export default connect(mapStateToProps)(AddOrder);